"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'UploadPhoto',
  data: function data() {
    return {
      avatar: null,
      avatarSrc: '',
      errorMessage: '',
      helperText: 'Faça o upload de fotos de até 50 MB.'
    };
  },
  methods: {
    triggerUploadInput: function triggerUploadInput() {
      this.$refs.uploadInput.click();
    },
    onFileChange: function onFileChange(event) {
      if (!event) return;
      var file = event.target.files[0];
      if (!file) return;
      var validTypes = ['image/png', 'image/jpeg'];
      var maxSize = 10 * 1024 * 1024;
      if (!validTypes.includes(file.type)) {
        this.errorMessage = 'Formato inválido. Use PNG ou JPEG.';
        return;
      }
      if (file.size > maxSize) {
        this.errorMessage = 'Arquivo upload-phototo grande. Máximo 10 MB.';
        return;
      }
      this.avatar = file;
      this.avatarSrc = URL.createObjectURL(file);
      this.errorMessage = '';
      this.$emit('change', file);
      this.$emit('input', file);
    },
    clearAvatar: function clearAvatar() {
      this.avatar = null;
      this.avatarSrc = '';
      this.errorMessage = '';
      this.$refs.uploadInput.value = null;
      this.$emit('change', null);
      this.$emit('input', null);
    }
  }
};